/**
 * SGKC023A
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface EmpposMstInfo {

    /**
     * 外部接続番号
     */
    extCnnctNo?: string;
}

